var cov_11yc4re1mn = function () {
  var path = "/Users/spana/SHEIN/shineout/src/AnimationList/index.tsx",
      hash = "626d6c2bccc3e51d567de5c9866cdff739b0ed73",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/AnimationList/index.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 13
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "1": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 16,
          column: 3
        }
      },
      "2": {
        start: {
          line: 8,
          column: 6
        },
        end: {
          line: 8,
          column: 20
        }
      },
      "3": {
        start: {
          line: 9,
          column: 6
        },
        end: {
          line: 9,
          column: 11
        }
      },
      "4": {
        start: {
          line: 11,
          column: 6
        },
        end: {
          line: 11,
          column: 20
        }
      },
      "5": {
        start: {
          line: 12,
          column: 6
        },
        end: {
          line: 12,
          column: 11
        }
      },
      "6": {
        start: {
          line: 14,
          column: 6
        },
        end: {
          line: 14,
          column: 54
        }
      },
      "7": {
        start: {
          line: 14,
          column: 40
        },
        end: {
          line: 14,
          column: 54
        }
      },
      "8": {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 15,
          column: 11
        }
      },
      "9": {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 18,
          column: 45
        }
      },
      "10": {
        start: {
          line: 18,
          column: 32
        },
        end: {
          line: 18,
          column: 45
        }
      },
      "11": {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 20,
          column: 48
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 13
          },
          end: {
            line: 5,
            column: 14
          }
        },
        loc: {
          start: {
            line: 5,
            column: 115
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 5
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 9,
            column: 11
          }
        }, {
          start: {
            line: 10,
            column: 4
          },
          end: {
            line: 12,
            column: 11
          }
        }, {
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 15,
            column: 11
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 14,
            column: 6
          },
          end: {
            line: 14,
            column: 54
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 14,
            column: 6
          },
          end: {
            line: 14,
            column: 54
          }
        }, {
          start: {
            line: 14,
            column: 6
          },
          end: {
            line: 14,
            column: 54
          }
        }],
        line: 14
      },
      "2": {
        loc: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 45
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 45
          }
        }, {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 45
          }
        }],
        line: 18
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import L from './List';
import hidable from '../hoc/hidable';
cov_11yc4re1mn.s[0]++;

var List = function List(type, duration, display) {
  cov_11yc4re1mn.f[0]++;
  cov_11yc4re1mn.s[1]++;

  switch (duration) {
    case 'fast':
      cov_11yc4re1mn.b[0][0]++;
      cov_11yc4re1mn.s[2]++;
      duration = 240;
      cov_11yc4re1mn.s[3]++;
      break;

    case 'slow':
      cov_11yc4re1mn.b[0][1]++;
      cov_11yc4re1mn.s[4]++;
      duration = 480;
      cov_11yc4re1mn.s[5]++;
      break;

    default:
      cov_11yc4re1mn.b[0][2]++;
      cov_11yc4re1mn.s[6]++;

      if (typeof duration !== 'number') {
        cov_11yc4re1mn.b[1][0]++;
        cov_11yc4re1mn.s[7]++;
        duration = 360;
      } else {
        cov_11yc4re1mn.b[1][1]++;
      }

      cov_11yc4re1mn.s[8]++;
      break;
  }

  cov_11yc4re1mn.s[9]++;

  if (typeof type === 'string') {
    cov_11yc4re1mn.b[2][0]++;
    cov_11yc4re1mn.s[10]++;
    type = [type];
  } else {
    cov_11yc4re1mn.b[2][1]++;
  }

  cov_11yc4re1mn.s[11]++;
  return hidable(L, {
    type: type,
    duration: duration,
    display: display
  });
};

export default List;